import { RepositorioBaseComFiltragemDeLeitura } from "@/http"
import {
  CriarUsuario,
  ListarUsuarios,
  ParamsUsuario,
  UsuarioLogado,
} from "./usuarios.modelo"
import { AxiosPromise } from "axios"
import { usarSerializador } from "@/composable/UsarSerializador/usarSerializador"
import { ResultadoApiGET } from "@/types/api"

const { paramsSerializer } = usarSerializador()

class UsuariosRepositorio extends RepositorioBaseComFiltragemDeLeitura {
  public listarUsuarios = (
    params?: ParamsUsuario
  ): Promise<ResultadoApiGET<ListarUsuarios>> =>
    this.instance.get("/api/usuarios", { params, paramsSerializer })

  public obterUsuarioLogado = (): Promise<UsuarioLogado> =>
    this.instance.get("/api/usuarios/eu")

  public obterFotoUsuario = (urlImagem: string): Promise<string> => {
    return this.instance.get(`/api/usuarios/foto/${urlImagem}`, {
      responseType: "arraybuffer",
    })
  }

  public atualizarFotoUsuario = (
    id?: string,
    usuario?: FormData
  ): Promise<{ id: string }> =>
    this.instance.post(`/api/usuarios/${id}/foto`, usuario, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

  public criarUsuario = (usuario?: CriarUsuario): Promise<{ id: string }> =>
    this.instance.post("/api/usuarios", usuario)

  public atualizarUsuario = (
    id?: string,
    usuario?: CriarUsuario
  ): Promise<{ id: string }> =>
    this.instance.patch("/api/usuarios/" + id, usuario)

  public editarUsuario = (
    usuario: CriarUsuario
  ): AxiosPromise<{ id: string }> =>
    this.instance.patch(`/api/usuarios/${usuario.id}`, usuario)

  public desativarUsuario = (id?: string[]): Promise<{ id: string[] }> =>
    this.instance.post("/api/usuarios/desativar", { id })

  public ativarUsuario = (id?: string[]): Promise<{ id: string[] }> =>
    this.instance.post("/api/usuarios/ativar", { id })
}

export default UsuariosRepositorio
